import { applyMiddleware, compose, createStore } from 'redux';
import { fb } from '../config/fbConfig';
import rootReducer from './reducers/rootReducer';
import thunk from 'redux-thunk';
import { getFirebase } from 'react-redux-firebase';
import { reduxFirestore, getFirestore } from 'redux-firestore';
import { persistStore, persistReducer, createTransform } from 'redux-persist';
import storage from 'redux-persist/lib/storage'
import { stringify, parse } from 'flatted';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const transformCircular = createTransform(
    (inboundState, key) => stringify(inboundState),
    (outboundState, key) => parse(outboundState),
)

const persistConfig = {
    key: 'adventour',
    storage,
    whitelist: ['auth'],
    stateReconciler: autoMergeLevel2,
    transforms: [transformCircular]
}

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(persistedReducer,
    composeEnhancers(
        applyMiddleware(
            thunk.withExtraArgument(
                { getFirebase, getFirestore }
            )
        ),
        reduxFirestore(fb)
    )
);

const persistor = persistStore(store)

export { store, persistor };